export const getVersionBack = (responseBack : string) => {
    if(!localStorage.getItem('version') && localStorage.getItem('version') !== responseBack){
        localStorage.setItem('version', !!responseBack ? responseBack : '');
    }
}